import {
    iCloudCredentialPromptDialogTitle,
    iCloudCredentialPromptDialogUserName,
    iCloudCredentialPromptDialogPassword,
    iCloudCredentialPromptDialogLogin,
} from './iCloudCredentialPromptDialog.locstring.json';
import { OwaModalProps } from 'owa-modal/lib/showModal';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47695 */
import * as React from 'react';
import { Dialog, DialogFooter } from '@fluentui/react/lib/Dialog';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { TextField } from '@fluentui/react/lib/TextField';

const styles = require('./iCloudCredentialPromptDialog.scss');

export interface ICloudCredentialPromptDialogInfo {
    userName: string;
    password: string;
}

export type ICloudCredentialPromptDialogProps = OwaModalProps<ICloudCredentialPromptDialogInfo>;

export default function ICloudCredentialPromptDialog(props: ICloudCredentialPromptDialogProps) {
    const [userName, setUserName] = React.useState(null);
    const [password, setPassword] = React.useState(null);

    const onSubmit = React.useCallback(event => {
        event.preventDefault();
        dismissWithTarget();
    }, []);

    const dismissWithTarget = React.useCallback(() => {
        props.onDismiss({
            userName: userName,
            password: password,
        });
    }, [userName, password]);

    const dismissEmpty = React.useCallback(() => {
        props.onDismiss({ userName: null, password: null });
    }, [props.onDismiss]);

    const onUpdateUserName = React.useCallback((event, newValue) => {
        setUserName(newValue);
    }, []);

    const onUpdatePassword = React.useCallback((event, newValue) => {
        setPassword(newValue);
    }, []);

    return (
        <Dialog
            hidden={false}
            title={loc(iCloudCredentialPromptDialogTitle)}
            onDismiss={dismissEmpty}
            minWidth={'388px'}
            maxWidth={'inherit'}>
            <form onSubmit={onSubmit}>
                <div
                    className={
                        !getUserConfiguration().UserOptions.IsDarkModeTheme && !isBrowserIE()
                            ? styles.openAnotherMailboxWellLine
                            : styles.openAnotherMailboxWellLineFallback
                    }>
                    <div>
                        <TextField
                            className={styles.textbox}
                            label={loc(iCloudCredentialPromptDialogUserName)}
                            onChange={onUpdateUserName}
                        />
                        <TextField
                            className={styles.textbox}
                            label={loc(iCloudCredentialPromptDialogPassword)}
                            type="password"
                            onChange={onUpdatePassword}
                        />
                    </div>
                </div>
                <DialogFooter>
                    <PrimaryButton
                        id="loginButton"
                        text={loc(iCloudCredentialPromptDialogLogin)}
                        onClick={dismissWithTarget}
                        disabled={!userName || !password}
                    />
                    <DefaultButton text={loc(cancelButton)} onClick={dismissEmpty} />
                </DialogFooter>
                <input className={styles.hideSubmit} type="submit" />
            </form>
        </Dialog>
    );
}
